var uiKit = {
  datepicker: {
    sunday: 'Domingo',
    monday: 'Lunes',
    tuesday: 'Martes',
    wednesday: 'Miércoles',
    thursday: 'Jueves',
    friday: 'Viernes',
    saturday: 'Sábado',
    sunday_short: 'D',
    monday_short: 'L',
    tuesday_short: 'M',
    wednesday_short: 'X',
    thursday_short: 'J',
    friday_short: 'V',
    saturday_short: 'S',
    january: 'Enero',
    february: 'Febrero',
    march: 'Marzo',
    april: 'Abril',
    may: 'Mayo',
    june: 'Junio',
    july: 'Julio',
    august: 'Agosto',
    september: 'Septiembre',
    october: 'Octubre',
    november: 'Noviembre',
    december: 'Diciembre',
    pick_year: 'Escoge un año',
    pick_month: 'Escoge un mes',
    pick_date: 'Escoge una fecha'
  }
};

export default {
  myaccount: {
    welcomeBar: {
      hi: 'Hola',
      lastLogin: 'Último Acceso',
      fullDate: '{{year}}-{{month}}-{{day}} {{hour}}',
      months: {
        '01': '01',
        '02': '02',
        '03': '03',
        '04': '04',
        '05': '05',
        '06': '06',
        '07': '07',
        '08': '08',
        '09': '09',
        10: '10',
        11: '11',
        12: '12'
      }
    },
    accountInfo: {
      id: 'ID'
    },
    accountVerification: {
      youHave: 'Te quedan',
      days: 'días',
      depositLeft: 'Saldo de depósito',
      pending: {
        accountUnverified: 'Tu cuenta está actualmente sin verificar',
        verifyNow: 'Verifica ahora',
        whyImportant: '¿Por qué esto es importante?'
      },
      rejected: {
        documentsRejected: 'Lamentablemente los documentos que enviaste han sido rechazados',
        documentsRejectedReason: 'Esto podría ser debido a una foto borrosa, que los datos no coincidan o estar usando un DNI erróneo.',
        documentsRejectedManualUpload: 'Intente subirlo manualmente'
      },
      inProgress: {
        verificationInProgress: '¡Gracias! Tus documentos serán verificados por nuestro equipo.',
        verificationInProgressInfo: 'Te notificaremos por email y SMS cuando se haya verificado tu identidad.'
      }
    },
    navigationMenu: {
      title: {
        myBets: 'Mis Apuestas',
        accountHistory: 'Historial de cuenta',
        withdraw: 'Retirar',
        reversalWithdraw: 'Cancelar Retiros',
        myRewards: 'Mis premios',
        myAccount: 'Mi Cuenta',
        depositLimit: 'Límites de depósitos',
        deposit: 'Depositar'
      }
    },
    myAccountTitles: {
      title: {
        accountHistory: 'Historial de cuenta',
        personalDetails: 'Datos personales',
        loginSecuritySettings: 'Ajustes de Inicio de Sesión y Seguridad',
        siteSettings: 'Ajustes'
      },
      listItems: {
        statementsView: 'Extracto de Cuenta',
        summaries: 'Resúmenes',
        contactName: 'Nombre de Contacto',
        contactDetails: 'Detalles de Contacto',
        marketingPreferences: 'Preferencias de Contactibilidad',
        autoLogin: 'Inicio de Sesión Automático',
        twoFactorAuth: 'Autenticación en dos Pasos',
        password: 'Contraseña',
        oddsFormat: 'Formato de Cuota',
        movementPrices: 'Fluctuación de Cuotas'
      }
    },
    accountButton: {
      gameActiveText: '{{mainBalance}}'
    },
    accountBonus: {
      messageText: '¡Tienes un bono en tu cuenta!'
    },
    header: {
      error: {
        message: 'No se ha podido obtener tus datos.',
        retry: 'Reintentar'
      },
      title: {
        landing: 'Mi Cuenta',
        myAccount: 'Mi Cuenta',
        myBets: 'Mis Apuestas',
        personalDetails: 'Datos personales',
        siteSettings: 'Ajustes de la cuenta',
        accountHistory: 'Historial de cuenta',
        loginSecurity: 'Inicio de sesión y Seguridad',
        summaryExport: 'Resumen de actividad anual',
        depositLimit: 'Límites de depósitos',
        deposit: 'Depositar'
      }
    },
    balanceAndBonus: {
      cashBalance: 'Saldo Principal',
      additionalBalance: { sportsbook: 'Bonus', gaming: 'Bonus', vegas: 'Bonus' }
    },
    transactions: {
      reference: 'Ref:',
      EW: 'G/C',
      eachWay: 'G/C 1-{{places}} Posiciones, {{price}} Cuota',
      stake: 'Apuesta',
      refund: 'Reembolsado',
      return: 'Ganancias',
      bonusStake: 'Apuesta Gratuita',
      stakeTotal: 'Apuesta Total',
      myBets: {
        open: 'Abiertas',
        settled: 'Cerradas'
      },
      price: {
        '@ SP': '@ PS',
        '@ Guaranteed Price': '@ Precio garantizado ({{price}})'
      },
      type: {
        BET_ACCUMULATOR_10: 'Combinada (10)',
        BET_ACCUMULATOR_11: 'Combinada (11)',
        BET_ACCUMULATOR_12: 'Combinada (12)',
        BET_ACCUMULATOR_13: 'Combinada (13)',
        BET_ACCUMULATOR_14: 'Combinada (14)',
        BET_ACCUMULATOR_15: 'Combinada (15)',
        BET_ACCUMULATOR_16: 'Combinada (16)',
        BET_ACCUMULATOR_17: 'Combinada (17)',
        BET_ACCUMULATOR_18: 'Combinada (18)',
        BET_ACCUMULATOR_19: 'Combinada (19)',
        BET_ACCUMULATOR_20: 'Combinada (20)',
        BET_ACCUMULATOR_21: 'Combinada (21)',
        BET_ACCUMULATOR_22: 'Combinada (22)',
        BET_ACCUMULATOR_23: 'Combinada (23)',
        BET_ACCUMULATOR_24: 'Combinada (24)',
        BET_ACCUMULATOR_25: 'Combinada (25)',
        BET_ACCUMULATOR_4: 'Cuadruple(s)',
        BET_ACCUMULATOR_5: 'Quíntuple(s)',
        BET_ACCUMULATOR_6: 'Séxtuple(s)',
        BET_ACCUMULATOR_7: 'Séptuple(s)',
        BET_ACCUMULATOR_8: 'Combinada (8)',
        BET_ACCUMULATOR_9: 'Combinada (9)',
        BET_CANADIAN: 'Canadian',
        BET_DDB: 'Tote - Daily Double',
        BET_DOUBLE: 'Doble(s)',
        BET_DOUBLES: 'Dobles',
        BET_EIGHTFOLDS: 'Combinadas de 8',
        BET_EXA: 'Tote - Exacta',
        BET_FIVEFOLDS: 'Quítuples',
        BET_FLG: 'Flag',
        BET_FOURFOLDS: 'Cuádruples',
        BET_GOLIATH: 'Goliath',
        BET_HEINZ: 'Heinz',
        BET_LUCKY_15: 'Lucky 15',
        BET_LUCKY_31: 'Lucky 31',
        BET_LUCKY_63: 'Lucky 63',
        BET_MAN: 'Written Bet',
        BET_NINEFOLDS: 'Combinadas de 9',
        BET_PATENT: 'Patent',
        BET_PK3: 'Tote - Pick 3',
        BET_PK4: 'Tote - Pick 4',
        BET_PK6: 'Tote - Pick 6',
        BET_PK9: 'Tote - Pick 9',
        BET_PLC: 'Tote - Place',
        BET_QIN: 'Tote - Quinella',
        BET_ROB: 'Round Robin',
        BET_SEVENFOLDS: 'Séptuples',
        BET_SHW: 'Tote - Show',
        BET_SINGLE: 'Simple',
        BET_SIXFOLDS: 'Séxtuples',
        BET_SPR: 'Tote - Superfecta',
        BET_SUPER_HEINZ: 'Super Heinz',
        BET_TENFOLDS: 'Combinadas de 10',
        BET_TREBLE: 'Triple(s)',
        BET_TREBLES: 'Triples',
        BET_TRI: 'Tote - Trifecta',
        BET_TRIXIE: 'Trixie',
        BET_UEXA: 'Tote - Exacta',
        BET_UJKP: 'Tote - Jackpot',
        BET_UKN: 'Apuesta',
        BET_UPLC: 'Tote - Place',
        BET_UPLP: 'Tote - Placepot',
        BET_UQDP: 'Tote - Quadpot',
        BET_USC6: 'Tote - Scoop 6',
        BET_USC7: 'Tote - Super7',
        BET_USW: 'Tote - Swinger',
        BET_UTD: 'Tote - Doble',
        BET_UTRI: 'Tote - Trifecta',
        BET_UTT: 'Tote - Triple',
        BET_UWIN: 'Tote - Win',
        BET_WIN: 'Tote - Win',
        BET_YANKEE: 'Yankee',
        BONUS: 'Ajuste de saldo',
        DEPOSIT: 'Depositar',
        PRIORITY_CARD_CASH: 'Efectivo',
        PRIORITY_CARD_CASHBACK: 'Purchase with cashback',
        PRIORITY_CARD_DEPOSIT: 'Depositar',
        PRIORITY_CARD_NON_CASH: 'No efectivo',
        PRIORITY_CARD_OTHER: 'Otros',
        PRIORITY_CARD_PURCHASE: 'Comprar',
        PRIORITY_CARD_QUASI_CASH: 'Quasi-cash',
        PRIORITY_CARD_REFUND: 'Devolución',
        PRIORITY_CARD_TRANSACTION: 'Pago',
        REVERSAL: 'Anular',
        MANUAL_ADJUSTMENT: 'Ajuste Manual',
        WITHDRAWAL: 'Retirada',
        TRANSFER: 'Trasladar',
        CASINO: 'Casino',
        SLOTS: 'Slots',
        VEGAS: 'Vegas'
      },
      manualAdjustmentType: {
        AFFP: 'Affiliate Payments',
        AFFR: 'Affiliate Rakeback',
        BCNV: 'Conversión de Saldo',
        BETC: 'Apuesta Corregida',
        BNJW: 'Ganancias de Jackpot',
        BNKC: 'Cargos del Banco',
        BONS: 'Bonos Manuales',
        BPCS: 'Pago de Bonos (cs)',
        BTCS: 'Transferencia de Saldo (cs)',
        CADJ: 'Ajuste de Comisión',
        CSH: 'Ajuste de Efectivo',
        CWIN: 'Cut Winnings',
        GWCS: 'Gesto de Buena Voluntad (cs)',
        GWIL: 'Gesto de Buena Voluntad',
        HEDG: 'Cobertura',
        INAC: 'Cargo por Inactividad',
        ISCS: 'Pago Incorrecto (cs)',
        LFND: 'Lost / Trapped Funds',
        MCM: 'Movimiento manual de saldo',
        ONCR: 'On-Course',
        PGCW: 'Pre GC Write Off',
        RCHQ: 'Return Cheque',
        SCHQ: 'Stop Cheque',
        TFCS: 'Trapped Funds (cs)',
        WOFF: 'Write Off'
      },
      result: {
        WIN: 'Ganada',
        LOST: 'Perdida',
        VOIDED: 'Anulada',
        CASHED_IN: 'Cobrada',
        STAKE: 'Cantidad apostada',
        CANCELED: 'Cancelada',
        PLACED: 'Colocado'
      },
      paymentMethod: {
        APPLEPAY: 'Apple Pay',
        BANKTRANSFER: 'Transferencia bancaria',
        CARD: 'Tarjeta de crédito/débito',
        CHEQUE: 'Cheque',
        CLICK2PAY: 'Click2Pay',
        CLICKANDBUY: 'Click And Buy',
        DIRECTBANKTRANSFER: 'Direct Bank Transfer',
        ECOPAYZ: 'EcoPayz',
        ENTROPAY: 'Entropay',
        ENVOY: 'Envoy',
        EPAYVOUCHER: 'ePay Voucher',
        NETELLER: 'Neteller',
        OTHER: 'Other',
        PAYPAL: 'PayPal',
        PAYSAFECARD: 'Paysafe Card',
        PINGIT: 'Pingit',
        PLUS: 'Plus Card',
        QUICKCASH: 'CashDirect',
        SKRILL: 'Skrill',
        UKASH: 'Ukash International',
        WESTERNUNION: 'Western Union',
        MUCHBETTER: 'MuchBetter'
      },
      sort: {
        ANYTIME_SCORECAST: 'Anytime Scorecast',
        ANYTIME_WINCAST: 'Anytime Wincast',
        ASIAN_HANDICAP: 'Asian Handicap',
        BYO: 'Build #YourOdds',
        COMBINATION_FIRST_FOUR: 'Combination First Four',
        COMBINATION_FORECAST: 'Combinación Forecast',
        COMBINATION_QUINELLA: 'Combinación Quinella',
        COMBINATION_TRICAST: 'Combinación Tricast',
        CONTINUOUS_WIN: 'Continuous Win',
        FIRST_FOUR: 'First Four',
        FIRST_HALF_ASIAN_HANDICAP: '1º Half Asian Handicap',
        FIRST_HALF_OUTRIGHT: '1º Half Outright',
        FIRST_HALF_WESTERN_HANDICAP: '1º Half Western Handicap',
        FIRST_WINCAST: 'First Wincast',
        FORECAST: 'Forecast',
        HIGHER_LOWER: 'Higher/Lower',
        HIGHER_LOWER_SPLIT_OFFER: 'Higher/Lower (with split offer)',
        INSURED_SCORECAST: 'Insured Scorecast',
        INSURED_WINCAST: 'Insured Wincast',
        LAST_SCORECAST: 'Last Scorecast',
        LAST_WINCAST: 'Last Wincast',
        MATCH_HANDICAP: 'Match Handicap',
        OVER_UNDER: 'Over/Under',
        PERMED_FORECAST: 'Forecast Permanente',
        PERMED_TRICAST: 'Tricast Permanente',
        POINTS_MARKET: 'Points Market',
        QUINELLA: 'Quinella',
        REVERSE_FORECAST: 'Forecast Reversa',
        SCORECAST: 'Scorecast',
        SECOND_HALF_ASIAN_HANDICAP: '2º Half Asian Handicap',
        SECOND_HALF_OUTRIGHT: '2º Half Outright',
        SECOND_HALF_WESTERN_HANDICAP: '2º Half Western Handicap',
        SIMPLE: 'Simple',
        STANDOUT_FIRST_FOUR: 'Standout First Four',
        STANDOUT_FORECAST: 'Standout Forecast',
        STANDOUT_QUINELLA: 'Standout Quinella',
        STANDOUT_TRICAST: 'Standout Tricast',
        STRAIGHT_FORECAST: 'Forecast Directa',
        TRICAST: 'Tricast',
        TRICAST_OPTIONS: 'Opciones de Tricast',
        WESTERN_HANDICAP: 'Western (straight) Handicap',
        XTH_SCORER_SCORECAST: 'Xth Scorer Scorecast',
        XTH_SCORER_WINCAST: 'Xth Scorer Wincast'
      },
      boostedBet: 'Boosted Bet',
      loadMore: 'Carga más',
      noTransactions: 'Ningunas transacciones',
      accountSummary: {
        buttonLabel: 'Descargue tu',
        buttonTitle: 'Resumen de actividad anual'
      },
      resetFilters: {
        filtersApplied: 'Filtros Aplicados',
        removeFilters: 'Quitar todos los filtros'
      }
    },
    filters: {
      dropdown: {
        transactionsHistory: {
          date: 'Últimos 7 días',
          filters: 'Filtros'
        }
      },
      customDateRange: {
        toLabel: 'to',
        labels: {
          from: 'desde',
          to: 'hasta'
        },
        error: ' Por favor selecciona un rango de fechas válido o selecciona una opción de fecha diferente.',
        historyLimitation: {
          caption: 'Por favor, ten en cuenta que las transacciones con más de un año de antigüedad podrían no estar disponibles. ' + 'Si quieres revisar estas transacciones, por favor, ponte en contacto con nuestro servicio de ',
          link: 'Atención al Cliente.'
        }
      },
      predefinedDateRange: {
        sectionName: 'Rango de fechas predefinido',
        allDates: 'Todas las fechas',
        last7: 'Últimos 7 días',
        last14: 'Últimos 14 días',
        last30: 'Últimos 30 días',
        custom: 'Rango personalizado'
      },
      view: {
        sectionName: 'Mostrar',
        all: 'Todo',
        onlyPayments: 'Sólo pagos (depósitos/retiros)',
        excludePayments: 'Excluir pagos (depósitos/retiros)',
        onlyWins: 'Sólo apuestas ganadoras',
        onlyLosses: 'Sólo apuestas perdedoras'
      },
      showHideBetTypes: {
        sectionName: 'Mostrar / Ocultar apuestas',
        singles: 'Simples',
        multiples: 'Múltiples'
      },
      tabs: {
        all: 'Todo',
        sports: 'Deportes',
        gaming: 'Casino / Juegos'
      },
      applyFilters: 'Aplicar'
    },
    footer: {
      button: {
        logout: {
          text: 'Salir'
        }
      },
      link: {
        feedback: 'Tu Opinión',
        help: 'Ayuda'
      }
    },
    autoAccept: {
      note: 'Auto aceptar movimiento de precios.',
      error: {
        save: 'Lo sentimos, tus datos no han podido ser grabados. Por favor, inténtalo de nuevo.'
      }
    },
    oddsFormat: {
      title: 'Formato de las cuotas',
      decimal: 'Decimal',
      fractional: 'Fraccionario'
    },
    accountSummary: {
      headerTitle: 'Elegir el resumen de actividad a descargar',
      reportTitle: 'Resumen de actividad anual',
      exportToPDF: 'Exportar en PDF',
      reportFileName: 'extracto_de_cuenta_{{year}}'
    },
    personalDetails: {
      tabs: {
        contact: 'Contacto',
        marketing: 'Marketing'
      }
    },
    personalDetailsContact: {
      securityMessage: {
        title: 'En William Hill nos tomamos muy en serio la seguridad y la privacidad de tu cuenta.',
        text: 'Guardamos tus datos de contacto en un lugar seguro, incluyendo tu nombre, dirección, número de teléfono' + ' y email. Para actualizar tus datos, completa los campos a continuación y haz clic en' + ' "Actualizar mis datos". Los datos actualizados se almacenarán en nuestros sistemas,' + ' pero no se mostrarán en la página.'
      },
      statusMessage: {
        success: 'Datos personales actualizados con éxito.',
        failure: 'Algo ha ido mal…'
      },
      fields: {
        email: {
          label: 'Email'
        },
        addressLine1: {
          label: 'Dirección (línea 1)'
        },
        addressLine2: {
          label: 'Dirección (línea 2)'
        },
        addressCity: {
          label: 'Población'
        },
        addressPostcode: {
          label: 'Código postal'
        },
        country: {
          label: 'País',
          defaultValue: 'Por favor selecciona de la lista.',
          password: 'Contraseña'
        },
        mobile: {
          label: 'Número de móvil'
        }
      },
      buttons: {
        submit: 'Actualizar mis datos'
      },
      validationRules: {
        email: {
          required: 'La dirección de correo electrónico no se puede quedar en blanco.',
          maxLength: 'Muy largo. Máximo 60 caracteres.',
          email: 'Debe ser una dirección de correo electrónico válida.'
        },
        street1: {
          required: 'La dirección es un campo obligatorio.',
          maxLength: 'Muy largo. Máximo 160 caracteres.',
          pattern: '¡Carácter inválido!'
        },
        street2: {
          required: 'La dirección es un campo obligatorio.',
          maxLength: 'Muy largo.',
          pattern: '¡Carácter inválido!'
        },
        city: {
          required: 'La ciudad es un campo obligatorio.',
          pattern: '¡Carácter inválido!',
          maxLength: 'Muy largo. Máximo 60 caracteres.'
        },
        postcode: {
          es: {
            required: 'El código postal no puede estar en blanco.',
            pattern: '¡Carácter inválido!',
            minLength: 'Muy corto. Debe tener 5 dígitos.',
            maxLength: 'Muy largo. Debe tener 5 dígitos.'
          },
          default: {
            required: 'El código postal no puede estar en blanco.',
            pattern: '¡Carácter inválido!',
            maxLength: 'Muy largo. Máximo 12 caracteres.'
          }
        },
        mobile: {
          required: 'El número de teléfono no se puede quedar en blanco.',
          pattern: 'Carácter inválido. Sólo se aceptan números.',
          minLength: 'Muy corto. Mínimo 6 caracteres.',
          maxLength: 'Muy largo. Máximo 20 caracteres.'
        }
      }
    },
    personalDetailsMarketing: {
      mainNote: 'Quiero recibir información sobre bonos, ofertas, promociones y servicios por email, SMS o teléfono. ' + 'Puedes actualizar/editar tus preferencias en cualquier momento.',
      contactMethodLabel: {
        telephone: 'Llamada',
        email: 'Email',
        sms: 'SMS'
      },
      error: {
        save: 'Lo sentimos, tus datos no han podido ser grabados. Por favor, inténtalo de nuevo.'
      },
      disclaimer: {
        text: 'Descargo de responsabilidad: ',
        note: 'Por favor ten en cuenta que los cambios pueden tardar hasta 48 horas en aplicarse. ' + 'Usamos las notificaciones en el móvil como parte de nuestros servicios. ' + 'Puedes controlar la configuración de las notificaciones en tu dispositivo (ajustes). ' + 'Si usas más de un dispositivo para acceder al servicio, ' + 'deberás ajustar la configuración en cada uno de ellos.'
      }
    },
    loginSecurity: {
      changePassword: 'Cambiar contraseña',
      currentPassword: 'Contraseña actual',
      newPassword: 'Nueva contraseña',
      savePassword: 'Guardar nueva contraseña',
      passwordUpdated: 'Tu contraseña se ha actualizado.',
      genericErrorMessage: 'Algo ha ido mal…',
      validationRules: {
        currentPassword: {
          required: 'El campo contraseña actual está vacío.',
          invalidCredentials: 'Contraseña Incorrecta.'
        },
        newPassword: {
          required: 'El campo nueva contraseña está vacío.',
          minLength: 'La nueva contraseña tiene menos de 8 o más de 15 caracteres.',
          maxLength: 'La nueva contraseña tiene menos de 8 o más de 15 caracteres.',
          hasDigit: 'La nueva contraseña no incluye alguno de los siguientes caracteres: un número, una letra minúscula y una letra mayúscula.',
          hasUppercaseLetter: 'La nueva contraseña no incluye alguno de los siguientes caracteres: un número, una letra minúscula y una letra mayúscula.',
          hasLowercaseLetter: 'La nueva contraseña no incluye alguno de los siguientes caracteres: un número, una letra minúscula y una letra mayúscula.',
          pattern: 'La nueva contraseña no incluye alguno de los siguientes caracteres: un número, una letra minúscula y una letra mayúscula.',
          cannotBeEqualToLastPassword: 'La nueva contraseña no puede ser igual a la última contraseña.',
          cannotContainFirstName: 'La nueva contraseña no puede incluir tu nombre.',
          cannotContainLastName: 'La nueva contraseña no puede incluir tu primer apellido.',
          cannotContainSecondLastName: 'La nueva contraseña no puede incluir tu segundo apellido.',
          cannotContainUsername: 'La nueva contraseña no puede incluir tu nombre de usuario.',
          cannotContainDateOfBirth: 'La nueva contraseña no puede incluir tu fecha de nacimiento.'
        },
        genericRules: 'Entre 8-15 caracteres. Sólo acepta números y letras. ' + 'Debe incluir un número, una letra minúscula y una mayúscula. ' + 'No puede incluir tu nombre, apellidos, nombre de usuario o año de nacimiento.'
      }
    },
    depositLimit: {
      label: 'Límites de depósitos',
      noticeMessage: 'Tienes la posibilidad de establecer límites en la cantidad de dinero a' + ' depositar en tu cuenta de William Hill en un período de 24 horas,' + ' semanalmente o mensualmente. ',
      noticeLinkLabel: '¿Cómo funciona?',
      ctaLabel: 'Salvar cambios',
      successMessage: 'Tus nuevos límites de depósito han sido fijados.',
      limits: {
        day: 'límite diario',
        week: 'límite semanal',
        month: 'límite mensual'
      },
      limitNotSet: 'No fijado.',
      chooseNewLimit: 'Elegir nuevo límite',
      inputPlaceholder: 'Elije un nuevo límite',
      increaseLimitLinks: {
        day: 'Quiero incrementar mi límite diario.',
        week: 'Quiero incrementar mi límite semanal.',
        month: 'Quiero incrementar mi límite mensual.'
      },
      pendingRequestText: 'Tu petición para aumentar tu {{limitLabel}} a {{requestAmount}} ' + 'será efectiva a partir del {{requestEffectiveFrom}}.',
      contactCustomerService: 'Al tener en proceso la petición del incremento del límite, no puedes cambiar tus límites actuales online. ' + 'Si quieres cambiarlas, por favor contacta con nuestro servicio de atención al cliente haciendo clic ',
      customerServiceLink: 'aquí.',
      otherValue: 'Otra cantidad',
      changePendingRequest: 'Si deseas cambiarlos, comunícate con nuestro servicio de atención al cliente haciendo clic'
    },
    error: {
      network: {
        text: 'Se ha producido un error en la conexión de red.',
        subText: 'Por favor vuelve a intentarlo en unos minutos.',
        retrySubText: 'Por favor reabran mi cuenta en unos momentos.'
      },
      graphQL: {
        text: 'Vaya, no hemos podido obtener tus datos.',
        subText: 'Por favor vuelve a intentarlo en unos minutos.',
        retrySubText: 'Por favor reabran mi cuenta en unos momentos.'
      },
      retry: 'Reintentar',
      iconAlt: 'Cono de tráfico'
    },
    loginPreferences: {
      title: 'Preferencias para iniciar sesión',
      options: {
        pin: 'Pin',
        faceID: 'Usar faceID',
        touchID: 'Usar touchID',
        none: 'No guardar los datos de inicio de sesión',
        autoLogin: 'Iniciar sesión automáticamente',
        rememberUserName: 'Recordar el nombre de usuario'
      },
      error: {
        save: 'Lo sentimos, tus datos no han podido ser grabados. Por favor, inténtalo de nuevo.'
      }
    }
  },
  countries: {
    COUNTRY_AD: 'Andorra',
    COUNTRY_AE: 'Emiratos Árabes Unidos',
    COUNTRY_AF: 'Afganistán',
    COUNTRY_AG: 'Antigua y Barbuda',
    COUNTRY_AI: 'Anguilla',
    COUNTRY_AL: 'Albania',
    COUNTRY_AM: 'Armenia',
    COUNTRY_AN: 'Antillas Holandesas',
    COUNTRY_AO: 'Angola',
    COUNTRY_AQ: 'Antártica',
    COUNTRY_AR: 'Argentina',
    COUNTRY_AS: 'Samoa Americana',
    COUNTRY_AT: 'Austria',
    COUNTRY_AU: 'Australia',
    COUNTRY_AW: 'Aruba',
    COUNTRY_AX: 'Islas Aland',
    COUNTRY_AZ: 'Azerbaiyán',
    COUNTRY_BA: 'Bosnia-Herzegovina',
    COUNTRY_BB: 'Barbados',
    COUNTRY_BC: 'Columbia Británica',
    COUNTRY_BD: 'Bangladesh',
    COUNTRY_BE: 'Bélgica',
    COUNTRY_BF: 'Burkina Faso',
    COUNTRY_BG: 'Bulgaria',
    COUNTRY_BH: 'Bahrein',
    COUNTRY_BJ: 'Benin',
    COUNTRY_BM: 'Bermuda',
    COUNTRY_BN: 'Brunei Darussalam',
    COUNTRY_BO: 'Bolivia',
    COUNTRY_BR: 'Brasil',
    COUNTRY_BS: 'Bahamas',
    COUNTRY_BT: 'Bután',
    COUNTRY_BV: 'Isla Bouvet',
    COUNTRY_BW: 'Botswana',
    COUNTRY_BY: 'Bielorrusia',
    COUNTRY_BZ: 'Belice',
    COUNTRY_CA: 'Canadá',
    COUNTRY_CC: 'Islas Cocos (Keeling)',
    COUNTRY_CD: 'República del Congo',
    COUNTRY_CF: 'República Centroafricana',
    COUNTRY_CG: 'Congo, República Democrática de',
    COUNTRY_CH: 'Suiza',
    COUNTRY_CI: 'Costa de Marfil',
    COUNTRY_CK: 'Islas Cook',
    COUNTRY_CL: 'Chile',
    COUNTRY_CM: 'Camerún',
    COUNTRY_CN: 'China',
    COUNTRY_CO: 'Colombia',
    COUNTRY_CR: 'Costa Rica',
    COUNTRY_CU: 'Cuba',
    COUNTRY_CV: 'Cabo Verde',
    COUNTRY_CX: 'Isla de Navidad',
    COUNTRY_CY: 'Chipre',
    COUNTRY_CZ: 'Republica Checa',
    COUNTRY_DE: 'Alemania',
    COUNTRY_DJ: 'Yibuti',
    COUNTRY_DK: 'Dinamarca',
    COUNTRY_DM: 'Dominica',
    COUNTRY_DO: 'República Dominicana',
    COUNTRY_DZ: 'Argelia',
    COUNTRY_EC: 'Ecuador',
    COUNTRY_EE: 'Estonia',
    COUNTRY_EG: 'Egipto',
    COUNTRY_EH: 'Sahara Occidental',
    COUNTRY_ER: 'Eritrea',
    COUNTRY_ES: 'España',
    COUNTRY_ET: 'Etiopía',
    COUNTRY_EU: 'Unión Europea',
    COUNTRY_FI: 'Finlandia',
    COUNTRY_FJ: 'Fiyi',
    COUNTRY_FK: 'Islas Malvinas (Falkland)',
    COUNTRY_FM: 'Micronesia',
    COUNTRY_FO: 'Islas Faroe',
    COUNTRY_FR: 'Francia',
    COUNTRY_FX: 'Francia metropolitana',
    COUNTRY_GA: 'Gabón',
    COUNTRY_GD: 'Granada',
    COUNTRY_GE: 'Georgia',
    COUNTRY_GG: 'Guernsey',
    COUNTRY_GF: 'Guyana Francesa',
    COUNTRY_GH: 'Ghana',
    COUNTRY_GI: 'Gibraltar',
    COUNTRY_GL: 'Groenlandia',
    COUNTRY_GM: 'Gambia',
    COUNTRY_GN: 'Guinea',
    COUNTRY_GP: 'Guadalupe',
    COUNTRY_GQ: 'Guinea Ecuatorial',
    COUNTRY_GR: 'Grecia',
    COUNTRY_GS: 'Georgia Del Sur',
    COUNTRY_GT: 'Guatemala',
    COUNTRY_GU: 'Guam',
    COUNTRY_GW: 'Guinea-Bissau',
    COUNTRY_GY: 'Guayana',
    COUNTRY_HK: 'Hong Kong',
    COUNTRY_HM: 'Islas Heard y McDonald',
    COUNTRY_HN: 'Honduras',
    COUNTRY_HR: 'Croacia',
    COUNTRY_HT: 'Haití',
    COUNTRY_HU: 'Hungría',
    COUNTRY_ID: 'Indonesia',
    COUNTRY_IE: 'Irlanda',
    COUNTRY_IL: 'Israel',
    COUNTRY_IM: 'Isla de Man',
    COUNTRY_IN: 'India',
    COUNTRY_IO: 'Territorio Británico del Océano Índico',
    COUNTRY_IQ: 'Iraq',
    COUNTRY_IR: 'Irán',
    COUNTRY_IS: 'Islandia',
    COUNTRY_IT: 'Italia',
    COUNTRY_JE: 'Jersey',
    COUNTRY_JM: 'Jamaica',
    COUNTRY_JO: 'Jordania',
    COUNTRY_JP: 'Japón',
    COUNTRY_KE: 'Kenia',
    COUNTRY_KG: 'Kirguizistán',
    COUNTRY_KH: 'Camboya',
    COUNTRY_KI: 'Kiribati',
    COUNTRY_KM: 'Comoros',
    COUNTRY_KN: 'San Cristóbal y Nieves',
    COUNTRY_KP: 'Corea (del Norte)',
    COUNTRY_KR: 'Corea del Sur',
    COUNTRY_KW: 'Kuwait',
    COUNTRY_KY: 'Islas Caimán',
    COUNTRY_KZ: 'Kazajstán',
    COUNTRY_LA: 'Laos',
    COUNTRY_LB: 'Líbano',
    COUNTRY_LC: 'Santa Lucía',
    COUNTRY_LI: 'Liechtenstein',
    COUNTRY_LK: 'Sri Lanka',
    COUNTRY_LR: 'Liberia',
    COUNTRY_LS: 'Lesotho',
    COUNTRY_LT: 'Lituania',
    COUNTRY_LU: 'Luxemburgo',
    COUNTRY_LY: 'Libia',
    COUNTRY_LV: 'Letonia',
    COUNTRY_MA: 'Marruecos',
    COUNTRY_MC: 'Mónaco',
    COUNTRY_MD: 'Moldova',
    COUNTRY_ME: 'Montenegro',
    COUNTRY_MG: 'Madagascar',
    COUNTRY_MH: 'Islas Marshall',
    COUNTRY_MK: 'Repúbica de Macedonia',
    COUNTRY_ML: 'Mali',
    COUNTRY_MM: 'Myanmar',
    COUNTRY_MN: 'Mongolia',
    COUNTRY_MO: 'Macao',
    COUNTRY_MP: 'Islas Marianas del Norte',
    COUNTRY_MQ: 'Martinica',
    COUNTRY_MR: 'Mauritania',
    COUNTRY_MS: 'Montserrat',
    COUNTRY_MT: 'Malta',
    COUNTRY_MU: 'Mauricio',
    COUNTRY_MV: 'Maldivas',
    COUNTRY_MW: 'Malawi',
    COUNTRY_MX: 'México',
    COUNTRY_MY: 'Malasia',
    COUNTRY_MZ: 'Mozambique',
    COUNTRY_NA: 'Namibia',
    COUNTRY_NC: 'Nueva Caledonia',
    COUNTRY_NE: 'Níger',
    COUNTRY_NF: 'Isla Norfolk',
    COUNTRY_NG: 'Nigeria',
    COUNTRY_NI: 'Nicaragua',
    COUNTRY_NL: 'Países Bajos (Holanda)',
    COUNTRY_NO: 'Noruega',
    COUNTRY_NP: 'Nepal',
    COUNTRY_NR: 'Nauru',
    COUNTRY_NU: 'Niue',
    COUNTRY_NZ: 'Nueva Zelanda',
    COUNTRY_OM: 'Omán',
    COUNTRY_PA: 'Panamá',
    COUNTRY_PE: 'Perú',
    COUNTRY_PF: 'Polinesia Francesa',
    COUNTRY_PG: 'Papúa Nueva Guinea',
    COUNTRY_PH: 'Filipinas',
    COUNTRY_PK: 'Paquistán',
    COUNTRY_PL: 'Polonia',
    COUNTRY_PM: 'San Pedro y Miquelón',
    COUNTRY_PN: 'Pitcairn',
    COUNTRY_PR: 'Puerto Rico',
    COUNTRY_PS: 'Territorios Palestinos',
    COUNTRY_PT: 'Portugal',
    COUNTRY_PW: 'Palau',
    COUNTRY_PY: 'Paraguay',
    COUNTRY_QA: 'Qatar',
    COUNTRY_RE: 'Reunión',
    COUNTRY_RO: 'Rumania',
    COUNTRY_RS: 'Serbia',
    COUNTRY_RU: 'Rusia',
    COUNTRY_RW: 'Ruanda',
    COUNTRY_SA: 'Arabia Saudita',
    COUNTRY_SB: 'Islas Salomón',
    COUNTRY_SC: 'Seychelles',
    COUNTRY_SD: 'Sudán',
    COUNTRY_SE: 'Suecia',
    COUNTRY_SG: 'Singapur',
    COUNTRY_SH: 'Santa Helena',
    COUNTRY_SI: 'Eslovenia',
    COUNTRY_SJ: 'Svalbard y Jan Mayen',
    COUNTRY_SK: 'Eslovaquia',
    COUNTRY_SL: 'Sierra Leona',
    COUNTRY_SM: 'San Marino',
    COUNTRY_SN: 'Senegal',
    COUNTRY_SO: 'Somalia',
    COUNTRY_SR: 'Surinam',
    COUNTRY_ST: 'Santo Tomé y Príncipe',
    COUNTRY_SV: 'El Salvador',
    COUNTRY_SY: 'Siria',
    COUNTRY_SZ: 'Swazilandia',
    COUNTRY_TA: 'Tristán de Acuña',
    COUNTRY_TC: 'Islas Turcas y Caicos',
    COUNTRY_TD: 'Chad',
    COUNTRY_TF: 'Territorios Franceses del Sur',
    COUNTRY_TG: 'Togo',
    COUNTRY_TH: 'Tailandia',
    COUNTRY_TJ: 'Tayikistán',
    COUNTRY_TK: 'Tokelau',
    COUNTRY_TM: 'Turkmenistán',
    COUNTRY_TN: 'Túnez',
    COUNTRY_TO: 'Tonga',
    COUNTRY_TP: 'Timor Oriental',
    COUNTRY_TR: 'Turquía',
    COUNTRY_TT: 'Trinidad y Tobago',
    COUNTRY_TV: 'Tuvalu',
    COUNTRY_TW: 'Taiwan',
    COUNTRY_TZ: 'Tanzania',
    COUNTRY_UA: 'Ucrania',
    COUNTRY_UG: 'Uganda',
    COUNTRY_UK: 'Reino Unido',
    COUNTRY_UM: 'Islas periféricas menores de Estados Unidos',
    COUNTRY_US: 'Estados Unidos de America',
    COUNTRY_UY: 'Uruguay',
    COUNTRY_UZ: 'Uzbequistán',
    COUNTRY_VA: 'Estado de la Ciudad del Vaticano (Santa Sede)',
    COUNTRY_VC: 'San Vicente y las Granadinas',
    COUNTRY_VE: 'Venezuela',
    COUNTRY_VG: 'Islas Vírgenes Británicas',
    COUNTRY_VI: 'Islas Vírgenes (EE. UU.)',
    COUNTRY_VN: 'Vietnam',
    COUNTRY_VU: 'Vanuatu',
    COUNTRY_WE: 'Samoa occidental',
    COUNTRY_WF: 'Islas Wallis y Futuna',
    COUNTRY_WS: 'Samoa',
    COUNTRY_YE: 'Yemen',
    COUNTRY_YT: 'Mayotte',
    COUNTRY_ZA: 'Sudáfrica',
    COUNTRY_ZM: 'Zambia',
    COUNTRY_ZW: 'Zimbabu'
  },
  'ui-kit': uiKit,
  date: {
    today: 'Hoy',
    months: {
      JAN: uiKit.datepicker.january,
      FEB: uiKit.datepicker.february,
      MAR: uiKit.datepicker.march,
      APR: uiKit.datepicker.april,
      MAY: uiKit.datepicker.may,
      JUN: uiKit.datepicker.june,
      JUL: uiKit.datepicker.july,
      AUG: uiKit.datepicker.august,
      SEP: uiKit.datepicker.september,
      OCT: uiKit.datepicker.october,
      NOV: uiKit.datepicker.november,
      DEC: uiKit.datepicker.december
    }
  }
};